<template>
  <img src="../../assets/image/yahoo_smartphone_purchase_PC.png" class="PClogo" alt="ヤフースマホ買取" />
  <img src="../../assets/image/yahoo_smartphone_purchase_SP.png" class="SPlogo" alt="ヤフースマホ買取" />
</template>

<style>
.PClogo {
  height: 20px;
  margin-right: 20px;
  margin-left: 2px;
  display: block;
}

.SPlogo {
  height: 20px;
  margin-right: 20px;
  margin-left: 2px;
  display: none;
}

@media screen and (max-width:768px) {
/*　画面サイズが768px以下はここを読み込む　*/
  .PClogo {
   display: none;
  }
    .SPlogo {
   display: block;
  }
}
</style>
